import React from 'react';
const CustomMarker = (props) => {

    let transformation = props.$hover || props.selected ? 'translate(-50%, -50%)' : 'translate(-50%, -60%)';
    let filter = props.$hover || props.selected ? 'hue-rotate(60deg)' : '';

    const getIcon = (category) => {
        let icons = props.categories.filter((cat) => {
            if(cat.slug === category) {
                return true;
            }
        });

        if (icons.length === 0) {
            return "fa-map-marker-alt";
        }

        return icons[0].icon ? 'fa-'+icons[0].icon : "fa-map-marker-alt";
    }

    const getColor = (category) => {
        let icons = props.categories.filter((cat) => {
            if(cat.slug === category) {
                return true;
            }
        });

        if (icons.length === 0) {
            return "#838383";
        }

        return icons[0].color ?? "#838383";
    }

    return (
        <div
            className="location-marker"
            data-toggle="tooltip"
        >
            {
                props.$hover || props.selected ?
                    <span className="marker-tooltip">{props.name}</span>
                    : null
            }
            <i
                className={"fa fa-lg attr solid circle-icon bd-mr-2 mb-2  " + getIcon(props.category) + (props.selected ? ' bg-accent' : '')}
                style={props.selected ? {fontSize: '35px', width: '60px', height: '60px', lineHeight: '50px'} : {backgroundColor: getColor(props.category)}}>
            </i>
        </div>
    )
};

export default CustomMarker;
